<div class="app-segment-bar">
  <div class="segment-group">
    <ng-content select="[segmentItems]"></ng-content>
  </div>
</div>
